// from https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript

import {readCachedLocalStorage, writeCachedLocalStorage} from "../Session/cachedLocalStorage";
import {getTaggedLogger} from "../Session/taggedLogging";
import {isEmpty} from "lodash";
import {trackKlaviyoEvent, trackViewedItemAttrs, withKlaviyo} from "../ExternalServices/Klaviyo/KlaviyoHelpers";

const CACHE_KEY = "klaviyoFormHistory";

const logger = getTaggedLogger('klaviyo');

/**
 * Called once by KlaviyoInformant at application startup, this will register an event
 * handler.
 *
 * @param callback
 */
export function trapKlaviyoFormEvents({callback} = {}) {

  window.addEventListener("klaviyoForms", function (e) {
    logger.log(`Klaviyo Form Event: ${JSON.stringify(e, null, 2)}`, e);

    // window.KLAVIYO_EVENTS ||= [];
    // KLAVIYO_EVENTS.push(e);

    // Automatically call our standard handler.
    let status = handleKlaviyoFormEvent(e);

    // ...and an optional callback.
    if (callback) {
      callback(e, status);
    }
  });
}

export function readKlaviyoFormHistory() {
  return readCachedLocalStorage(CACHE_KEY,
    {defaultValue: {}});
}

export function writeKlaviyoFormHistory(formStatus) {
  writeCachedLocalStorage(CACHE_KEY, formStatus);

  logger.info("updated klaviyo status: ", formStatus);
}

export function handleKlaviyoFormEvent(event) {
  event ||= {};

  let now = new Date();

  const {detail = {}} = event;

  const {formId, type: eventType, metaData = {}} = detail;
  const {$email, $phone_number} = (metaData || {});

  if (!formId) {
    logger.error("no form ID in klaviyo event: ", event);
    return;
  }

  // Events I don't care about.
  if (eventType === 'stepSubmit' || eventType === 'viewedStep') {
    return;
  }

  let formStatus = readKlaviyoFormHistory();

  let entry = (formStatus[formId] ||= {formId, openCount: 0, touchedAt: now.getTime()});

  if ($email)
    entry.email = $email;
  if ($phone_number)
    entry.phoneNumber = $phone_number;

  if (eventType === 'open') {
    entry.status = 'open';
    entry.openCount = 1 + (+entry.openCount);
    entry.openedAt = now.getTime();
  } else if (eventType === 'submit') {
    entry.status = 'submitted';
    entry.submitted = true;
    entry.closedAt = now.getTime();

  } else if (eventType === 'close') {
    entry.status = 'closed';
    entry.closedAt = now.getTime();
  } else {
    logger.info(`ignoring klaviyo form event ${eventType} on form ${formId}`)
  }

  writeKlaviyoFormHistory(formStatus);
  return formStatus;
}




// klaviyo.openForm('SAraHJ')

/*

 grab event.detail from each:
 TODO add a timestamp
 good events:
 stepSubmit - multiple times per form
 submit - once, has main payload

 detail.metaData.{email, phone_number, stepName, ...additional fields}

 */
